const letterSpacings = {
    core: {
        "0": "-0.05em",
        "1": "-0.04em",
        "2": "-0.03em",
        "3": "-0.02em",
        "4": "-0.01em",
        "5": "0em",
    },
};
export default letterSpacings;
//# sourceMappingURL=letterSpacings.js.map